module.exports = __webpack_public_path__ + "ff53055f48802cba0e5ecb5fa898ed16.svg";